import { render } from "./Eventos.vue?vue&type=template&id=acc97ae2&scoped=true"
import script from "./Eventos.vue?vue&type=script&lang=js"
export * from "./Eventos.vue?vue&type=script&lang=js"

import "./Eventos.vue?vue&type=style&index=0&id=acc97ae2&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acc97ae2"]])

export default __exports__